import { render } from "./ProfiLineComponent.vue?vue&type=template&id=f533fd38"
import script from "./ProfiLineComponent.vue?vue&type=script&lang=js"
export * from "./ProfiLineComponent.vue?vue&type=script&lang=js"

import "./ProfiLineComponent.vue?vue&type=style&index=0&id=f533fd38&lang=scss"
script.render = render

export default script